module.exports = __webpack_public_path__ + "static/media/lamcraft_logo.1ee5401b.png";